export const COMPONENT_HTML_SUFFIX = '.component.html';
